import { SidebarLink } from "@faire/deprecated-retailer-visitor-shared/components/Filter/filter-components/Components/SidebarLink";
import { useMaybeAssignCategoryTreeExperiment } from "@faire/deprecated-retailer-visitor-shared/lib/useMaybeAssignCategoryTreeExperiment";
import { ILeftNavLink } from "@faire/deprecated-retailer-visitor-shared/views/category/__internal__/CategoryPageRoot/__internal__/CategoryPageShareables/LeftNav/__internal__/ILeftNavLink";
import { IRecordCategoryNodesVisibilityRequest } from "@faire/web-api--source/indigofair/category/IRecordCategoryNodesVisibilityRequest";
import { useStrictLocalization } from "@faire/web/common/localization";
import uniq from "lodash/uniq";
import React, { useEffect } from "react";
import styled from "styled-components";

import Source = IRecordCategoryNodesVisibilityRequest.Source;

interface IProps {
  options?: ILeftNavLink[];
  selectedIdentifier?: string;
  optionDataTestId?: string;
}

const recursivelyGetChildCategoryPathIdentifiers = (
  links: ILeftNavLink[],
  selectedCategoryPathIdentifier?: string
): string[] => {
  return links
    .filter(
      (link) =>
        selectedCategoryPathIdentifier &&
        link.identifier?.startsWith(selectedCategoryPathIdentifier)
    )
    .flatMap((link) => [
      link.identifier ?? "",
      ...recursivelyGetChildCategoryPathIdentifiers(
        link.childNavLinks,
        selectedCategoryPathIdentifier
      ),
    ]);
};

export const LeftNavInner = ({
  options,
  selectedIdentifier,
  optionDataTestId,
}: IProps) => {
  const { strictLocalize } = useStrictLocalization();
  const maybeAssignCategoryTreeExperiment =
    useMaybeAssignCategoryTreeExperiment();

  useEffect(() => {
    if (options !== undefined) {
      maybeAssignCategoryTreeExperiment(
        () =>
          uniq(
            recursivelyGetChildCategoryPathIdentifiers(
              options,
              selectedIdentifier
            )
          ),
        Source.WEB_DESKTOP_LEFT_NAV
      );
    }
  }, [options, selectedIdentifier, maybeAssignCategoryTreeExperiment]);

  return (
    <Container
      data-test-id="category-page-sidebar"
      aria-label={strictLocalize({
        id: "NoaLqW",
        defaultMessage: "Side Navigation",
        description: {
          text: "Accessible label for side navigation",
        },
      })}
    >
      <ul>
        {(options ?? []).map((option) => (
          <li key={option.to}>
            <SidebarLink
              dataTestId={optionDataTestId}
              option={option}
              selectedIdentifier={selectedIdentifier}
            />
          </li>
        ))}
      </ul>
    </Container>
  );
};

const Container = styled.nav`
  margin-bottom: 8px;
`;
